import { jsx as _jsx } from "react/jsx-runtime";
export function Page(_a) {
    var children = _a.children, className = _a.className;
    return _jsx("div", { className: className, children: children });
}
//# sourceMappingURL=Page.js.map